<template lang="pug">
  v-row
    v-col

      create-widget(
        @created="init"
      )

      h1.ma-4 Мои виджеты
      v-row(v-if="loading")
        v-col(v-for="n in 3" xl="3" lg="4" md="6" cols="12"  :key="`sl${n}`")
          v-skeleton-loader(
            class="mx-auto"
            type="card"
          )
      v-row(v-else)
        v-col(
          v-for="item in items"
          :key="item.id"
          cols="12" sm="6" md="4" lg="4" xl="3"
        )
          v-card.sdo-card
            div(v-html="item.href")
            v-card-text
              v-textarea(
                :value="item.href"
                hint="Кликните для копирования"
                persistent-hint
                filled
                readonly
                @click="copyToClipboard"
              )
            v-card-text
              v-btn(
                @click="openDeleteDialog(item.id)"
                color="error"
                fab
                small
                depressed
              ): v-icon mdi-delete
        v-slide-y-reverse-transition
          v-col(v-if="!loading && !items.length" class="text-center")
            span(class="grey--text") Виджеты отсутствуют

    delete-dialog(
      v-model="showDeleteDialog"
      :request="this.$api.widgets.delete"
      :request-id="this.deleteId"
      @delete="onDeleteWidget"
    )
      template(v-slot:body) Вы действительно хотите удалить данный виджет?
</template>

<script>
import copyToClipboard from '@/utils/copy-clipboard';

import CreateWidget from '../components/CreateWidget.vue';

export default {
  name: 'WidgetList',
  components: { CreateWidget },
  data: () => ({
    items: [],

    deleteId: null,
    showDeleteDialog: false,

    loading: false,
    loadingDelete: false,
  }),
  created() {
    this.getWidgets();
  },
  methods: {
    init() {
      this.getWidgets();
    },
    async getWidgets() {
      this.loading = true;
      await this.$rHandler(
        this.$api.widgets.index(),
        (r) => {
          this.items = r.data.data;
        },
      );
      this.loading = false;
    },
    async onDeleteWidget() {
      this.items = this.items.filter((w) => w.id !== this.deleteId);
      this.deleteId = null;
      this.showDeleteDialog = false;
    },
    openDeleteDialog(id) {
      this.deleteId = id;
      this.showDeleteDialog = true;
    },
    copyToClipboard(event) {
      const codeContainer = event.target;
      copyToClipboard(codeContainer);
      this.$toasted.info('Код виджета скопирован в буфер обмена', { duration: 5000 });
    },
  },
};
</script>
